import { Button, Popconfirm, TableProps } from 'antd'
import { FC } from 'react'
import { Relay as IRelay, RelayType } from '../helpers/types/relay'
import EditableTable from '../components/Table'
import { relayStore } from '../store/relay'
import { PageBreadcrumb } from '../components/PageBreadcrumb'

export const Relay: FC = () => {
	const {
		fetchRelaysByType,
		relayTypes,
		createRelayType,
		addRelayType,
		addRelay,
		deleteRelayType,
		createRelay,
		deleteRelay
	} = relayStore()

	interface DataType {
		key: React.Key
		id: string
		name: string
		createdAt: string
	}

	type ColumnTypes = Exclude<
		TableProps<DataType>['columns'],
		undefined
	>

	// const handleDelete = (key: React.Key) => {
	// 	const newData = dataSource.filter((item) => item.id !== key)
	// 	setDataSource(newData)
	// }

	// if (!relayTypes.length) {
	// 	return <></>
	// }

	return (
		<div>
			<PageBreadcrumb items={[{ label: 'Реле' }]} />
			<header
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center'
				}}>
				<h1>Тип реле</h1>
				<Button type="primary" onClick={addRelayType}>
					Добавить тип реле
				</Button>
			</header>
			<main>
				<EditableTable
					scroll={{ x: 768 }}
					columns={
						[
							{
								title: 'Название',
								dataIndex: 'name',
								key: 'name',
								editable: true,
								className: 'table-cell-name'
							},
							{
								title: 'Добавлено',
								dataIndex: 'createdAt',
								key: 'createdAt',
								render(_: any, record: RelayType) {
									return (
										<div>
											{new Date(
												record.createdAt
											).toLocaleDateString(
												'ru-RU'
											)}
										</div>
									)
								}
							},
							{
								title: 'Действие',
								key: 'operation',
								render: (
									_: any,
									record: RelayType
								) => {
									return record.isNew ? (
										<></>
									) : (
										<Popconfirm
											title="Sure to delete?"
											onConfirm={() =>
												deleteRelayType(
													record.id
												)
											}>
											<Button danger>
												Delete
											</Button>
										</Popconfirm>
									)
								}
							}
						] as (ColumnTypes[number] & {
							editable?: boolean
							dataIndex: string
						})[]
					}
					dataSource={relayTypes.map((item) => ({
						...item,
						key: item.id
					}))}
					handleAdd={addRelayType}
					handleSave={createRelayType}
					expandable={{
						rowExpandable: (record) => !record.isNew,
						expandedRowRender: (record: RelayType) => {
							if (!record.relays) {
								return <></>
							}

							if (!record.relays.length) {
								return (
									<div
										style={{
											textAlign: 'center'
										}}>
										<h3>Реле не найдено</h3>
										<Button
											type="primary"
											onClick={() =>
												addRelay(record.id)
											}>
											Добавить реле
										</Button>
									</div>
								)
							}

							return (
								<>
									<div
										style={{
											textAlign: 'center'
										}}>
										<Button
											type="primary"
											onClick={() =>
												addRelay(record.id)
											}>
											Добавить реле
										</Button>
									</div>
									<EditableTable
										columns={
											[
												{
													title: 'Название',
													dataIndex: 'name',
													key: 'name',
													editable: true
												},
												{
													title: 'Уникальный номер',
													dataIndex:
														'relayUnique',
													key: 'relayUnique',
													editable: true
												},
												{
													title: 'Год выпуска',
													dataIndex:
														'madeYear',
													key: 'madeYear',
													editable: true
												},
												{
													title: 'Срок службы',
													dataIndex:
														'expiration',
													key: 'expiration',
													editable: true
												},
												{
													title: 'Действие',
													key: 'operation',
													render: (
														_: any,
														record: IRelay
													) => {
														return record.isNew ? (
															<></>
														) : (
															// <Popconfirm
															// 	title="Sure to delete?"
															// 	onConfirm={() =>
															// 		handleSave(record.id)
															// 	}>
															// 	<Button danger>
															// 		Delete
															// 	</Button>
															// </Popconfirm>
															<Popconfirm
																title="Sure to delete?"
																onConfirm={() =>
																	deleteRelay(
																		record.relayTypeId,
																		record.id
																	)
																}>
																<Button
																	danger>
																	Delete
																</Button>
															</Popconfirm>
														)
													}
												}
											] as (ColumnTypes[number] & {
												editable?: boolean
												dataIndex: string
											})[]
										}
										dataSource={record.relays.map(
											(relay) => ({
												...relay,
												key: relay.id
											})
										)}
										handleAdd={() =>
											addRelay(record.id)
										}
										handleSave={createRelay}
									/>
								</>
							)
						},
						onExpand: (expanded, record: IRelay) => {
							if (expanded) {
								fetchRelaysByType(record.id)
							}
						}
					}}
					rowClassName={() => 'editable-row'}
				/>
			</main>
		</div>
	)
}
